/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_UnitInputs */

const vi_confirm_return_unit = /** @type {(inputs: Confirm_Return_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đơn vị`)
};

/**

* @param {Confirm_Return_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_unit = /** @type {((inputs?: Confirm_Return_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_unit(inputs)
});